(function(){
  "use strict";
  function onReady(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function normalizeText(root){
    var pairs = [
      ['Ultra-Potent Nootropic','Nootrópico de alta potencia'],
      ['Ultra Potent','Alta potencia'],
      ['Memory Boost','Impulso de memoria'],
      ['Capsule Form','Formato cápsulas'],
      ['Research Grade','Calidad de investigación'],
      ['Default Title','Presentación estándar'],
      ['Ver Stacks (combinaciones listas)','Ver combinaciones listas'],
      ['Stacks listos','Combinaciones listas']
    ];
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while((node = walker.nextNode())){
      var value = node.nodeValue;
      if(!value || !value.trim()) continue;
      var next = value;
      pairs.forEach(function(pair){ next = next.replaceAll(pair[0], pair[1]); });
      if(next !== value) node.nodeValue = next;
    }
  }

  function cleanupCollectionClutter(){
    document.querySelectorAll('.nm-stacks-strip').forEach(function(el){ el.remove(); });
  }

  function tidyCart(){
    document.querySelectorAll('.nm-cart-revenue-box,.nm-cart-reco,.nm-cart-drawer__upsells,[class*="cart-upsell"],[data-upsell]').forEach(function(el){ el.remove(); });
  }

  onReady(function(){
    normalizeText(document.body);
    cleanupCollectionClutter();
    tidyCart();
    var mo = new MutationObserver(function(){
      normalizeText(document.body);
      cleanupCollectionClutter();
      tidyCart();
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  });
})();
